module.exports = __webpack_public_path__ + "img/logo_pln_caption.c85271a8.png";